module.exports = __webpack_public_path__ + "static/media/cover.5761186d.png";